var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 330,
    viewBox: "0 0 80 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-227.31 328.065C-208.395 304.676 -204.276 300.97 -184.867 286.154C-180.112 282.523 -170.868 276.812 -159.45 271.357C-156.034 269.722 -152.646 268.239 -149.305 266.88C-125.397 257.187 -98.6144 255.818 -72.1635 258.071C-4.67446 263.82 56.2375 227.288 73.9948 171.977C91.7806 116.571 62.5204 55.045 16.8602 25.0231C10.9189 21.1171 -17.1169 3.88706 -47.8766 1.34009C-144.996 -6.72848 -183.804 87.3478 -213.187 230.491C-213.757 233.276 -215.93 246.533 -216.319 249.346L-227.319 328.074L-227.31 328.065Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector12);
export default __webpack_public_path__ + "static/media/vector1-2.4882feccef526511f2283aa424f27a96.svg";
export { ForwardRef as ReactComponent };